module.exports = __webpack_public_path__ + "img/simulation.63c87966.png";